import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { ToastService } from '@app/shared/services/toast.service';

@Injectable()
export class UserEffects {
  constructor(private actions$: Actions, private _ToastService: ToastService) {}
}
